import React, { useMemo } from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { DealRedeemItem } from "../../../api/admin/webshop/dealRedeems/DealRedeemItem";

interface Props {
  data: DealRedeemItem[];
}

interface ReportRow {
  promoCode: string;
  totalRedemptions: number;

  totalCartValue: number;
  totalDiscount: number;
}

export const RedemptionReport: React.FC<Props> = ({ data }) => {
  const reportData = useMemo(() => {
    if (!data) return [];

    const aggregated: Record<string, ReportRow> = {};

    data.forEach((item) => {
      const code = item.promoCode || "Unknown";
      if (!aggregated[code]) {
        aggregated[code] = {
          promoCode: code,
          totalRedemptions: 0,
          totalCartValue: 0,
          totalDiscount: 0,
        };
      }
      aggregated[code].totalRedemptions += 1;
      aggregated[code].totalCartValue += item.cartTotal || 0;
      aggregated[code].totalDiscount += item.discountAmount || 0;
    });

    return Object.values(aggregated).sort(
      (a, b) => b.totalRedemptions - a.totalRedemptions,
    );
  }, [data]);

  const columns: ColumnsType<ReportRow> = [
    {
      title: "Code Name",
      dataIndex: "promoCode",
      key: "promoCode",
    },
    {
      title: "Total Redemptions",
      dataIndex: "totalRedemptions",
      key: "totalRedemptions",
    },
    {
      title: "Total Cart Value",
      dataIndex: "totalCartValue",
      key: "totalCartValue",
      render: (val: number) => val.toFixed(2),
    },
    {
      title: "Total Discount",
      dataIndex: "totalDiscount",
      key: "totalDiscount",
      render: (val: number) => val.toFixed(2),
    },
  ];

  return (
    <Table
      rowKey="promoCode"
      dataSource={reportData}
      columns={columns}
      pagination={false}
    />
  );
};
